<template>
  <div>
    <div class="billing-payments__saved-methods">
      <div v-if="isMethodsLoading" class="billing-payments__loading">
        <q-spinner-dots color="primary" size="40px" />
      </div>
      <div v-else-if="paymentMethods.length === 0" class="billing-payments__no-methods">
        <q-icon name="o_credit_card_off" size="32px" color="grey-6" class="billing-payments__empty-icon" />
        <p class="billing-payments__empty-title">No payment methods</p>
        <p class="billing-payments__empty-subtitle">Add a payment method to upgrade your plan</p>
      </div>
      <div v-else class="billing-payments__methods-list">
        <div v-for="method in sortedPaymentMethods" :key="method.id" class="billing-payments__method-item" :class="{ 'billing-payments__method-item--default': method.is_default === 'true' }">
          <div class="billing-payments__method-icon">
            <img v-if="hasCardImage(method.type)" :src="require(`@/assets/${method.type.toLowerCase()}.png`)" height="24" width="36" class="billing-payments__card-brand-icon" />
            <q-icon v-else name="credit_card" size="24px" color="grey-7" />
          </div>
          <div class="billing-payments__method-details">
            <span class="billing-payments__method-name"> {{ method.type | capitalize }} • ending {{ method.last4_digit }} </span>
          </div>
          <div class="billing-payments__method-actions">
            <span v-if="method.is_default === 'true'" class="billing-payments__method-default"> Default </span>
            <q-btn round flat dense size="sm" icon="more_horiz" class="billing-payments__method-menu">
              <q-menu anchor="bottom right" self="top right" class="billing-payments__dropdown-menu">
                <q-list class="billing-payments__dropdown-list">
                  <q-item v-if="method.is_default !== 'true'" clickable v-close-popup @click="$emit('set-default', method)" class="billing-payments__dropdown-item">
                    <q-item-section side class="billing-payments__dropdown-icon">
                      <q-icon name="o_credit_score" color="terziary" />
                    </q-item-section>
                    <q-item-section>
                      <div class="billing-payments__dropdown-item-text">Set as default</div>
                    </q-item-section>
                  </q-item>
                  <q-item clickable v-close-popup @click="$emit('remove', method)" class="billing-payments__dropdown-item billing-payments__dropdown-item--danger">
                    <q-item-section side class="billing-payments__dropdown-icon">
                      <q-icon name="o_delete" color="terziary" />
                    </q-item-section>
                    <q-item-section>
                      <div class="billing-payments__dropdown-item-text">Remove this card</div>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="billing-payments__btn-container">
      <q-btn flat class="billing-payments__add-btn" size="sm" @click="$emit('open-add')">
        <q-icon name="add" size="xs" class="q-mr-xs" />
        <span>Add payment method</span>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentMethodsList',
  computed: {
    ...mapGetters({
      paymentMethods: 'billing/paymentMethods',
      isLoading: 'billing/isPaymentMethodsLoading',
      isInitialLoading: 'billing/isInitialLoading'
    }),

    isMethodsLoading() {
      return this.isLoading || this.isInitialLoading;
    },

    // Sort payment methods to ensure default is always at the top
    sortedPaymentMethods() {
      if (!this.paymentMethods?.length) return [];

      // Simple sorting using the default flag - most efficient approach
      return [...this.paymentMethods].sort(
        (a, b) =>
          // Convert string 'true'/'false' to boolean and compare
          (b.is_default === 'true') - (a.is_default === 'true')
      );
    }
  },
  methods: {
    hasCardImage(type) {
      const supportedCards = ['visa', 'mastercard'];
      return supportedCards.includes(type.toLowerCase());
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './billing-payments-styles.scss';
</style>
